import { render, staticRenderFns } from "./icon-monochrome-cross.vue?vue&type=template&id=d0e1b522&"
import script from "./icon-monochrome-cross.vue?vue&type=script&lang=js&"
export * from "./icon-monochrome-cross.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports